export enum BleConnectionState {
  DISCONNECTED = 'DISCONNECTED',
  ATTEMPTING_CONNECT = 'ATTEMPTING_CONNECT',
  CONNECTED = 'CONNECTED',
  ERROR_CONNECTING = 'ERROR_CONNECTING',
}

export enum BleUpdateFirmwareState {
  /** Firmware update was successful */
  SUCCESS = 'SUCCESS',
  /** Firmware update failed while fetching the firmware */
  FAILURE_FETCHING = 'FAILURE_FETCHING',
  /** Firmware update failed due to licensing */
  FAILURE_LICENSING = 'FAILURE_LICENSING',
  /** Firmware update failed during installation */
  FAILURE_INSTALLING = 'FAILURE_INSTALLING',
  /** Firmware install has not happened or was cleared. */
  UNDEFINED = 'UNDEFINED',
}
